import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const trendingMovies = movies.filter((m) => m.trending).slice(0, 6);

export default function TrendingSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900">热播榜单</h2>
          <span className="bg-accent-100 text-accent-700 text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
            HOT
          </span>
        </div>
        <Link
          to="/category/dianshiju"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap transition-colors"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {trendingMovies.map((movie, index) => (
          <div key={movie.id} className="relative">
            {index < 3 && (
              <span className="absolute -top-2 -left-2 z-10 w-7 h-7 rounded-full bg-accent-500 text-background-50 text-xs font-bold flex items-center justify-center">
                {index + 1}
              </span>
            )}
            <MovieCard
              id={movie.id}
              title={movie.title}
              year={movie.year}
              rating={movie.rating}
              genre={movie.genre}
              posterUrl={movie.posterUrl}
              isNew={movie.isNew}
            />
          </div>
        ))}
      </div>
    </section>
  );
}